import { LayerContentType, type DenormalizedCreationState } from '@pixum/types';
import { convertAlbumImageToLayerContent } from '@pixum/creation-state';
import type { ImageInformation } from 'stores/express-designer';

type DenormalizedLayer = DenormalizedCreationState['layersById'][string];

function fillImageLayer(layer: DenormalizedLayer, image: ImageInformation): DenormalizedLayer {
  if (layer.type !== LayerContentType.IMAGE) {
    return layer;
  }

  return { ...layer, data: convertAlbumImageToLayerContent(image) };
}

function fillLayersById(
  layersById: DenormalizedCreationState['layersById'],
  image: ImageInformation
): DenormalizedCreationState['layersById'] {
  return Object.fromEntries(Object.entries(layersById).map(([uuid, layer]) => [uuid, fillImageLayer(layer, image)]));
}

export function fillCreationWithImage(
  creation: DenormalizedCreationState,
  image: ImageInformation
): DenormalizedCreationState {
  return { ...creation, layersById: fillLayersById(creation.layersById, image) };
}
